import { Bookmark } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BookmarkButtonProps {
  isSaved: boolean;
  onClick: (e: React.MouseEvent) => void;
  /** "icon" for card overlay, "button" for detail page */
  variant?: "icon" | "button";
  className?: string;
}

export function BookmarkButton({ isSaved, onClick, variant = "icon", className }: BookmarkButtonProps) {
  if (variant === "button") {
    return (
      <Button
        variant="outline"
        size="lg"
        className={cn("w-full gap-2", className)}
        onClick={onClick}
      >
        <Bookmark className={cn("h-4 w-4", isSaved && "fill-primary text-primary")} />
        {isSaved ? "Vaga salva" : "Salvar esta vaga"}
      </Button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "p-1.5 rounded-lg transition-colors hover:bg-muted",
        isSaved ? "text-primary" : "text-muted-foreground hover:text-foreground",
        className,
      )}
      aria-label={isSaved ? "Remover dos salvos" : "Salvar vaga"}
    >
      <Bookmark className={cn("h-4 w-4", isSaved && "fill-primary")} />
    </button>
  );
}
